module.exports = require("yaml-js");


//////////////////
// WEBPACK FOOTER
// external "yaml-js"
// module id = 610
// module chunks = 0